import React from 'react';
import PropTypes from 'prop-types';
import ModalOperatorItem from '../ModalOperatorItem';
import useTranslation from 'hooks/useTranslation';

const ModalOperatorList = ({
  operators,
  searchText,
  selectedOperatorIds,
  setSelectedOperatorIds,
}) => {
  const { getTranslation } = useTranslation("WEBSITES");
  const { t } = getTranslation();

  const handleOperatorSelection = (newId) => {
    if (!selectedOperatorIds.includes(newId)) {
      addToSelectedIds(newId);
      return;
    }
    removeFromSelectedIds(newId);
  };

  const addToSelectedIds = (idToAdd) => {
    setSelectedOperatorIds((prevSelectedIds) => [...prevSelectedIds, idToAdd]);
  };

  const removeFromSelectedIds = (idToRemove) => {
    const filteredOperatorIds = selectedOperatorIds.filter(
      (id) => id !== idToRemove
    );
    setSelectedOperatorIds(filteredOperatorIds);
  };

  const renderOperatorListHeadlineSection = (
    <div className='modal__container__body__agents__title'>
      <h4 className='modal__container__body__agents__title__inner'>
        {t("MODAL").ASSIGN_OPERATOR_OPERATORS}
      </h4>
      <p className='modal__container__body__agents__title__description'>
        {t("MODAL").ASSIGN_OPERATOR_HINT}
      </p>
    </div>
  );

  return (
    <>
      {renderOperatorListHeadlineSection}
      <div className='modal__container__body__agents__list flex flex-jc-s flex-ai-s flex-wrap'>
        {operators.data &&
          operators.data
            .filter((operator) => operator.fullName?.includes(searchText))
            .map((operator) => {
              const { id, fullName, imageUrl } = operator;
              const checked = selectedOperatorIds.includes(id) ? 'checked' : '';
              return (
                <ModalOperatorItem
                  key={id}
                  operatorId={id}
                  fullName={fullName}
                  imageUrl={imageUrl}
                  onOperatorSelect={() => handleOperatorSelection(id)}
                  hasChecked={checked}
                />
              );
            })}
      </div>
    </>
  );
};

ModalOperatorList.propTypes = {
  operators: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired,
    })
  ),
  searchText: PropTypes.string.isRequired,
  selectedOperatorIds: PropTypes.arrayOf(PropTypes.string.isRequired),
  setSelectedOperatorIds: PropTypes.func.isRequired,
};

export default ModalOperatorList;
